import React, { Component } from 'react';
import { RankList } from '../../components/rankList/rankList';
import { BlurBackground } from '../../components/blurBackground/blurBackground';
import { Spinner } from '../../../components/Spinner/spinner';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { ShareOnTwitter } from 'components/Button/shareButton';

import PrimusHandler from '../../../api/primusHandler';
import 'react-toastify/dist/ReactToastify.css';
import './codeSubmit.css';

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
ChartJS.register(ArcElement, Tooltip, Legend);

const noSession = true;
class CodeSubmit extends Component {
  state = {
    rankList: [],
    isLoader: false,
    pageContent: null,
    isSubmitForm: false,
    isTournament: false,
    isSessionExist: false,
  };

  componentDidMount() {
    if (this.props.match.params.isTournament === 'true') {
      this.setState(
        {
          isTournament: true,
        },
        () => {
          this.getSubmissionData();
        }
      );
    } else {
      this.getSubmissionData();
    }
    if (parseInt(this.props.match.params.xpAmount) > 0) {
      toast.success(`You've gained ${this.props.match.params.xpAmount} Xp !`);
    }
    PrimusHandler.sendRequest({ _handler: 'load-contest', _id: this.props.match.params.contestId }, noSession);
    PrimusHandler.sendRequest(
      { _handler: 'load-challenge-rankList', _id: this.props.match.params.contestId },
      noSession
    );
  }

  UNSAFE_componentWillReceiveProps(props) {
    const content = props.get_content;
    const rankList = props.challenge_rankList;
    const submitResponse = props.submission_score_data;

    if (content && content.data) {
      this.setState({ content: content.data.landingPageContent, pageContent: content.data });
      if (document.getElementById('main-tournament')) {
        document.getElementById('main-tournament').style.backgroundImage = `url("${content.data.contestBackground}")`;
      }
    } else if (content && content.error) {
      toast(content.error);
    }

    if (rankList && rankList.data) {
      this.setState({ rankList: rankList.data });
    } else if (rankList && rankList.error) {
      toast(rankList.error);
    }

    if (submitResponse && submitResponse.data) {
      this.setState({
        percentage: submitResponse.data.percent,
        score: submitResponse.data.score,
        textToShare: submitResponse.data.textToShare,
        isLoader: false,
        isSubmitForm: true,
      });
    } else if (submitResponse && submitResponse.error) {
      toast(submitResponse.error);
      this.setState({ isLoader: false });
    }
  }

  getSubmissionData = () => {
    let params = {
      _handler: 'update-challenge-submission',
      solutionId: this.props.match.params.solutionId,
      isTournament: this.state.isTournament,
      action: 'getSubmissionScore',
      isReact: true,
    };
    this.setState({ isLoader: true });
    PrimusHandler.sendRequest(params);
    if (!this.state.isTournament) {
      let interval = setInterval(() => {
        if (this.state.isSubmitForm) {
          clearInterval(interval);
          PrimusHandler.sendRequest(
            { _handler: 'load-challenge-rankList', _id: this.props.match.params.contestId },
            noSession
          );
        }
      }, 1000);
    }
  };

  renderHighScore() {
    const data = {
      labels: ['Percentage', 'Other Candidates'],
      datasets: [
        {
          data: [this.state.percentage, 100 - this.state.percentage],
          backgroundColor: ['#1ec6a3', '#14a788'],
        },
      ],
    };
    return (
      <div className="main-container custom-container">
        <center>
          <h1 className="result-heading">Thank you for participating!</h1>
          <div style={{ height: 300, width: 300 }}>
            <Pie
              width={100}
              height={100}
              data={data}
              options={{
                legend: {
                  display: false,
                },
              }}
            />
          </div>
          <div className="result-wrapper my-4">
            <div className="row col-lg-12 col-sm-12">
              <div className="col-sm-12 col-lg-3">
                <div className="displayScore ">
                  {this.state.percentage}
                  <span className="resultPercentage">%</span>
                </div>
              </div>
              <div className="result-message col-sm-12 col-lg-9">
                <p className="resultMessageText">
                  {`Nice one, your score was ${this.state.score}, which is better than ${this.state.percentage}% of the other participants.`}
                </p>
              </div>
            </div>
          </div>
          <ShareOnTwitter
            url={`${window.location.origin}/challenge/${this.props.match.params.contestId}`}
            title={this.state.textToShare}
          />
          <h3 className="heading">Highscore</h3>
          <div className="score-container">
            <div className="table-container">
              <RankList
                rankList={this.state.rankList}
                isOfficialChallenge={
                  this.state.pageContent && this.state.pageContent.tags
                    ? this.state.pageContent.tags.includes('Official')
                    : false
                }
              />
            </div>
          </div>
          <div className="container">
            <p
              dangerouslySetInnerHTML={{
                __html: this.state.pageContent ? this.state.pageContent.resultPageContent : '',
              }}
              className="resultMessageText"
            ></p>
          </div>
        </center>
      </div>
    );
  }

  renderSubmitTournament() {
    return (
      <BlurBackground>
        <h1>Well done!</h1>
        <h3 className="centered-text">
          Visit this <Link to={`/challenges/${this.props.match.params.contestId}`}>link</Link> tomorrow to see your
          placement in the highscore ladder!
        </h3>
        {this.state.pageContent && this.state.pageContent.companyDescription ? (
          <div dangerouslySetInnerHTML={{ __html: this.state.pageContent.companyDescription }}></div>
        ) : null}
      </BlurBackground>
    );
  }

  render() {
    if (this.state.isTournament) {
      return (
        <div id="main-tournament" className="app-container">
          {this.renderSubmitTournament()}
          {this.state.isLoader && (
            <div className="main-container">
              <Spinner />
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div style={{ height: '100%' }}>
          {<div>{this.renderHighScore()} </div>}
          {this.state.isLoader && (
            <div className="main-container">
              <Spinner />
            </div>
          )}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    get_content: state.data['load-contest'],
    challenge_rankList: state.data['load-challenge-rankList'],
    submission_score_data: state.data['update-challenge-submission'],
  };
}

export default connect(mapStateToProps, null)(CodeSubmit);
